import i18n from '@/lang';

const maxQuantity = 9999;

function quantityValidator(rule, value) {
  const numValue = +value;
  if (numValue && numValue > maxQuantity) {
    return Promise.reject(
      new Error(`${i18n.global.t('common.quantity_length')}${maxQuantity}`)
    );
  }

  return Promise.resolve();
}

export function validateQuantity() {
  return { validator: quantityValidator };
}

export function validateLength(length) {
  return {
    max: length,
    message: `${i18n.global.t('common.max_length')}${length}`
  };
}
